import { TRootState }    from 'Redux/Reducers';
import { arrayContains } from 'Utils';
import Actions           from 'Redux/Actions';

export const isEventLoading = (state: TRootState): boolean =>
  arrayContains(state.event.openRequests, [
    Actions.findEventRequest.type,
    Actions.findEventsRequest.type,
    Actions.createEventRequest.type,
    Actions.updateEventRequest.type,
    Actions.deleteEventRequest.type,
  ]);
